import { BankPanelTabs } from './BankPanelTabs/BankPanelTabs.tsx';
import { AceCard } from '../AceCard';
import { QuoteDataForm } from './QuoteDataForm/QuoteDataForm.tsx';
import {
  useLoanApplication,
  useLoanQuotes,
} from '@axo/shared/data-access/hooks';

export const BankPanel = ({ applicationID }: { applicationID: string }) => {
  const { data: formQuotesData } = useLoanQuotes(applicationID);
  const { data: applicationData } = useLoanApplication(applicationID);

  if (!applicationData) return null;
  return (
    <AceCard
      id={`BankPanel.${applicationID}`}
      title="Bank panel"
      noContentPadding
    >
      <QuoteDataForm data={formQuotesData} application={applicationData}>
        <BankPanelTabs applicationID={applicationID} />
      </QuoteDataForm>
    </AceCard>
  );
};
